import { render, staticRenderFns } from "./ContactInfoPanel.vue?vue&type=template&id=37bf8a19&scoped=true&"
import script from "./ContactInfoPanel.vue?vue&type=script&lang=js&"
export * from "./ContactInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoPanel.vue?vue&type=style&index=0&id=37bf8a19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bf8a19",
  null
  
)

export default component.exports